// Phone number validation (Indian 10-digit mobile, digits only in UI)
export const validatePhoneNumber = (phone) => {
  const digits = phone.replace(/\D/g, '');
  return /^[0-9]{10}$/.test(digits);
};

// PIN validation
export const validatePIN = (pin) => {
  const pinRegex = /^[0-9]{4,6}$/;
  return pinRegex.test(pin);
};

// Email validation
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Name validation
export const validateName = (name) => {
  return name.trim().length >= 2 && name.trim().length <= 50;
};

// Price validation
export const validatePrice = (price) => {
  return price >= 0 && price <= 999999.99;
};

// Order amount validation
export const validateOrderAmount = (amount) => {
  return amount > 0 && amount <= 999999.99;
};

// Form validation helpers
export const getPhoneError = (phone) => {
  if (!phone) return 'Phone number is required';
  if (!validatePhoneNumber(phone)) return 'Enter a valid 10-digit mobile number';
  return '';
};

export const getPINError = (pin) => {
  if (!pin) return 'PIN is required';
  if (!validatePIN(pin)) return 'PIN must be 4-6 digits';
  return '';
};

export const getNameError = (name) => {
  if (!name) return 'Name is required';
  if (!validateName(name)) return 'Name must be 2-50 characters';
  return '';
};

export const getPriceError = (price) => {
  if (price < 0) return 'Price cannot be negative';
  if (price > 999999.99) return 'Price is too high';
  return '';
};

export const getOrderAmountError = (amount) => {
  if (amount <= 0) return 'Order amount must be greater than 0';
  if (amount > 999999.99) return 'Order amount is too high';
  return '';
};

// Cart validation
export const validateCartItem = (item) => {
  return (
    item &&
    item.itemID &&
    item.name &&
    typeof item.price === 'number' &&
    item.price >= 0 &&
    typeof item.quantity === 'number' &&
    item.quantity > 0
  );
};

// Order validation
export const validateOrder = (order) => {
  return (
    order &&
    order.OrderID &&
    order.orderAmount > 0 &&
    order.orderItemsList &&
    order.orderItemsList.length > 0 &&
    order.outletId &&
    order.userId
  );
};
